import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  orderDetailsWrapper: {
    height: '100%',
    paddingLeft: 20,
    marginRight: -20,
    overflow: 'hidden'
  },
  arrowBack: {
    margin: '11px 8px 0 0'
  },
  backToOrdersContainer: {
    display: 'flex'
  }
}))

export default useStyles
